"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _colors = _interopRequireDefault(require("../../styles/colors"));

var spaceDefaults = {
  main: ['xlarge', null, 'xlarge'],
  wrapperStyle: {},
  childStyle: {}
};
var spacing = {
  horizon: _objectSpread({}, spaceDefaults),
  lionsCreativity: {
    main: ['xxlarge', null, 'xxxlarge'],
    wrapperStyle: {
      '> *:last-of-type': {
        borderBottom: '0'
      }
    },
    childStyle: {
      borderBottom: '1px solid',
      borderBottomColor: '#BBBBBB'
    }
  },
  money2020: _objectSpread(_objectSpread({}, spaceDefaults), {}, {
    wrapperStyle: {
      '> *:nth-of-type(2n+1)': {
        background: _colors.default.money2020.offwhite
      },
      '> *:nth-of-type(2n+2)': {
        background: 'white'
      }
    },
    main: ['xlarge', null, 'xxlarge']
  })
};
var _default = spacing;
exports.default = _default;